module.exports = __webpack_public_path__ + "img/building-01.8d1b6ee8.webp";